import { smtpConfig } from "../environments/environment";
export const BodyEmail = function(
  to,
  digitableLine,
  debtor,
  codeCobra,
  contractNumber,
  Attachmentbase64str,
  nameOffice
) {
  return {
    to: to,
    digitableLine: digitableLine,
    debtor: debtor,
    codeCobra: codeCobra,
    contractNumber: contractNumber,
    attachmentName: `${new Date().toISOString()}-${codeCobra}.pdf`,
    attachmentbase64str: Attachmentbase64str,
    nameOffice: nameOffice
  };
};
